import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./app/app.module').then(m => m.AppModule)
  },

  {
    path: 'account',
    loadChildren: () =>
      import('account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('admin/admin.module').then(m => m.AdminModule)
  },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class RootRoutingModule {}
